import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-contnt-grid-view',
  templateUrl: './contnt-grid-view.component.html',
  styleUrls: ['./contnt-grid-view.component.css']
})
export class ContntGridViewComponent implements OnInit {
  @Input() items: any;
  @Input() isRoot: boolean;
  @Input() isPreviewMode: boolean;
  @Input() pinnedItem: any;
  @Input() hasPinnedItem : boolean;
  @Input() productThumb: any;
  @Output() onFileAction = new EventEmitter<any>();
  @Output() onSelect = new EventEmitter<any>();

  constructor() { }

  hasTouch: boolean = false;
  ngOnInit() { 
    this.hasTouch = this.isTouchDevice();
  }
  
  isTouchDevice(){
      return window.ontouchstart !== undefined;
  }
  onFileActionClicked(e:any, item:any, action: string) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    e.item = item;
    e.action = action;
    this.onFileAction.emit(e);
  }

  onContentButtonClicked(e:any) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    this.onFileAction.emit(e);
  }


  selectFileForPreview(e:any, item:any) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    e.item = item;
    this.onSelect.emit(e);
  }

  onFileSelect(e:any) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    this.onSelect.emit(e);
  }
}



// WEBPACK FOOTER //
// ./public/app/common/contnt-grid-view/contnt-grid-view.component.ts